module.exports = __webpack_public_path__ + "img/voice_0.b8047dc1.png";